module.exports = __webpack_public_path__ + "public/img/towerBigScreenHead.3ecf4529.png";